// extracted by mini-css-extract-plugin
module.exports = {"root":"info_root_3H8T_","textover":"info_textover_3TPYT","img":"info_img_iSVVm","img2":"info_img2_14R2m","text":"info_text_1bc8S","bgcolor":"info_bgcolor_24OGr"};